(() => {
  if (customElements.get('ea-home-carousel')) return;
  customElements.define('ea-home-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track], .eah__products--carousel');
      this.controls = this.querySelector('.eah__carousel-controls');
      this.prev = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      if (!this.track) return;
      this.update = () => {
        if (!this.isConnected) return;
        const end = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = end < 2;
        this.prev.disabled = this.track.scrollLeft < 2;
        this.next.disabled = this.track.scrollLeft >= end - 2;
      };
      this.move = direction => {
        const card = this.track.firstElementChild;
        const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : this.track.clientWidth;
        this.track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.onClick = event => {
        if (event.target.closest('[data-carousel-prev]')) this.move(-1);
        if (event.target.closest('[data-carousel-next]')) this.move(1);
      };
      this.onKey = event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      };
      this.onScroll = () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(this.update); };
      this.addEventListener('click', this.onClick);
      this.track.addEventListener('keydown', this.onKey);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      if ('ResizeObserver' in window) { this.observer = new ResizeObserver(this.update); this.observer.observe(this.track); }
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.removeEventListener('click', this.onClick);
      this.track?.removeEventListener('keydown', this.onKey);
      this.track?.removeEventListener('scroll', this.onScroll);
    }
  });
})();
